<template>
  <nav class="sidebar-nav">
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="psSettings"
      @ps-scroll-y="scrollHandle"
    >
      <ul class="nav">
        <template v-for="(item, index) in navItems">
          <template v-if="item.title">
            <SidebarNavTitle
              :key="index"
              :name="item.name"
              :classes="item.class"
              :wrapper="item.wrapper"
            />
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :key="index" :classes="item.class" />
          </template>
          <template v-else-if="item.label">
            <SidebarNavLabel
              :key="index"
              :name="item.name"
              :url="item.url"
              :icon="item.icon"
              :label="item.label"
              :classes="item.class"
            />
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <SidebarNavDropdown
                :key="index"
                :name="item.name"
                :displayName="item.shortName || item.name"
                :url="item.url"
                :icon="item.icon"
              >
                <template v-for="(childL1, index1) in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown
                      :key="index1"
                      :name="childL1.name"
                      :displayName="childL1.shortName || childL1.name"
                      :url="childL1.url"
                      :icon="childL1.icon"
                    >
                      <li
                        :key="index2"
                        class="nav-item"
                        v-for="(childL2, index2) in childL1.children"
                      >
                        <SidebarNavLink
                          :name="childL2.name"
                          :displayName="childL2.shortName || childL2.name"
                          :url="childL2.url"
                          :icon="childL2.icon"
                          :badge="childL2.badge"
                          :variant="childL2.variant"
                          :attributes="childL2.attributes"
                        />
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem :key="index1" :classes="item.class">
                      <SidebarNavLink
                        :name="childL1.name"
                        :displayName="childL1.shortName || childL1.name"
                        :url="childL1.url"
                        :icon="childL1.icon"
                        :badge="childL1.badge"
                        :variant="childL1.variant"
                        :attributes="childL1.attributes"
                      />
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem :key="index" :classes="item.class">
                <SidebarNavLink
                  :name="item.name"
                  :displayName="item.shortName || item.name"
                  :url="item.url"
                  :icon="item.icon"
                  :badge="item.badge"
                  :variant="item.variant"
                  :attributes="item.attributes"
                />
              </SidebarNavItem>
            </template>
          </template>
        </template>
      </ul>
      <slot></slot>
    </VuePerfectScrollbar>
  </nav>
</template>

<script>
import SidebarNavDivider from "@/components/Sidebar/SidebarNavDivider";
import SidebarNavDropdown from "@/components/Sidebar/SidebarNavDropdown";
import SidebarNavLink from "@/components/Sidebar/SidebarNavLink";
import SidebarNavTitle from "@/components/Sidebar/SidebarNavTitle";
import SidebarNavItem from "@/components/Sidebar/SidebarNavItem";
import SidebarNavLabel from "@/components/Sidebar/SidebarNavLabel";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "SidebarNav",
  components: {
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel,
    VuePerfectScrollbar,
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: [],
    },
  },
  computed: {
    psSettings: () => {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction !== "rtl",
        wheelPropagation: false,
        interceptRailY: (styles) => ({ ...styles, height: 0 }),
      };
    },
  },
  methods: {
    scrollHandle() {
      // Scroll handler for perfect scrollbar
    },
  },
};
</script>

<style scoped lang="css">
.sidebar-nav {
  position: relative;
  height: 100%;
}

.scroll-area {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding-bottom: 4.5rem;
  overflow-anchor: none;
  scrollbar-gutter: auto;
}

.sidebar .nav-dropdown.open {
  background: none;
  color: #fff;
}

@media (min-width: 992px) {
  .sidebar-minimized .sidebar .scroll-area,
  .sidebar-minimized .sidebar .nav {
    padding-bottom: 4.5rem;
  }

  .sidebar-minimized .sidebar .scroll-area::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 56px;
    background: linear-gradient(
      180deg,
      rgba(15, 23, 42, 0) 0%,
      rgba(23, 48, 107, 0.94) 42%,
      rgba(23, 48, 107, 1) 100%
    );
    pointer-events: none;
    z-index: 20;
  }
}
</style>
<style lang="css">
@media (min-width: 1200px) {
  .sidebar-fixed .sidebar {
    width: 215px;
  }

  .sidebar .sidebar-nav .ps,
  .sidebar .sidebar-nav,
  .sidebar .nav {
    width: 100% !important;
  }

  .sidebar .sidebar-nav .scroll-area {
    width: 100% !important;
    padding-right: 0 !important;
    scrollbar-gutter: auto;
    box-sizing: border-box;
  }

  .sidebar .sidebar-nav .ps__rail-y,
  .sidebar .sidebar-nav .ps__thumb-y {
    right: 0 !important;
  }
}
</style>
